import { useReducer } from "react";
import { BookingsChart } from "../BookingsChart";
import { DEFAULT_INTERVAL_CONFIG } from "../BookingsChart/constants";
import { getBucketCountForInterval, getDateRangeForInterval } from "../BookingsChart/helpers";
import { BookingsChartNavigation } from "../BookingsChartNavigation";
import { chartReducer, getIsChartDefaultExpanded, type ChartState, type ChartVisibilityState } from "./chartReducer";
import { type BookingFilters } from "@/routes/(authed)/_layout/bookings.route";

export { type ChartVisibilityState } from "./chartReducer";

interface BookingsForecastProps {
  filters: BookingFilters;
  setFilters: React.Dispatch<React.SetStateAction<BookingFilters>>;
}

export function BookingsForecast({ filters, setFilters }: BookingsForecastProps) {
  const [state, dispatch] = useReducer(chartReducer, initialState);

  return (
    <div>
      <BookingsChartNavigation
        referenceDate={state.referenceDate}
        visibility={state.visibility}
        onChartStateChange={() => dispatch({ type: "TOGGLE_CHART_VISIBILITY" })}
        intervalType={state.intervalType}
        onNavigateNext={() => dispatch({ type: "NAVIGATE_NEXT" })}
        onNavigatePrevious={() => dispatch({ type: "NAVIGATE_PREVIOUS" })}
        onResetToToday={() => dispatch({ type: "RESET_TO_TODAY" })}
      />
      <BookingsChart
        visibility={state.visibility}
        setFilters={setFilters}
        filters={filters}
        intervalType={state.intervalType}
        dateRange={state.dateRange}
        onIntervalTypeChange={(intervalType) => dispatch({ type: "SET_INTERVAL", intervalType })}
        referenceDate={state.referenceDate}
        onNavigateNext={() => dispatch({ type: "NAVIGATE_NEXT" })}
        onNavigatePrevious={() => dispatch({ type: "NAVIGATE_PREVIOUS" })}
        onResetToToday={() => dispatch({ type: "RESET_TO_TODAY" })}
      />
    </div>
  );
}

const initialState: ChartState = {
  referenceDate: new Date(),
  visibility: (getIsChartDefaultExpanded() ? "expanded" : "collapsed") satisfies ChartVisibilityState,
  intervalType: DEFAULT_INTERVAL_CONFIG.defaultInterval,
  dateRange: getDateRangeForInterval({
    referenceDate: new Date(),
    intervalType: DEFAULT_INTERVAL_CONFIG.defaultInterval,
    bucketCount: getBucketCountForInterval(DEFAULT_INTERVAL_CONFIG.defaultInterval),
  }),
};
